import { supabase } from './supabase';
import type { Category, ContentPack, Language } from './types';

export async function loadReferences(): Promise<{
  languages: Language[];
  categories: Category[];
  packs: ContentPack[];
}> {
  const [languagesResult, categoriesResult, packsResult] = await Promise.all([
    supabase.from('languages').select('*').order('label'),
    supabase.from('categories').select('*').order('sort_order'),
    supabase.from('content_packs').select('*').order('name'),
  ]);

  if (languagesResult.error) throw languagesResult.error;
  if (categoriesResult.error) throw categoriesResult.error;
  if (packsResult.error) throw packsResult.error;

  return {
    languages: (languagesResult.data ?? []) as Language[],
    categories: (categoriesResult.data ?? []) as Category[],
    packs: (packsResult.data ?? []) as ContentPack[],
  };
}

export async function fetchAllRows<T>(
  table: string,
  select = '*',
  pageSize = 1000,
): Promise<T[]> {
  const rows: T[] = [];
  let from = 0;

  while (true) {
    const { data, error } = await supabase
      .from(table)
      .select(select)
      .range(from, from + pageSize - 1);
    if (error) throw error;

    const batch = (data ?? []) as T[];
    rows.push(...batch);
    if (batch.length < pageSize) break;
    from += pageSize;
  }

  return rows;
}
